import { useToggle } from 'react-use'
import { FC, MouseEventHandler } from 'react'
import SecondaryButton from '@organisms/SecondaryButton'
import { CopyOutlined } from '@ant-design/icons'
import Modal from '@organs/Modal'
import PositionAndDangersModal from '@modals/PositionAndDangersModal'
import { useLazyGetRiskMapPositionQuery } from '@services/riskMapJobPositions'

type Props = {
  positionAndDangersId: number
}

const CopyPositionAndDangers: FC<Props> = ({ positionAndDangersId }) => {
  const [modalIsVisible, toggleModalIsVisible] = useToggle(false)

  const [getRiskMapPosition, { data, isLoading }] =
    useLazyGetRiskMapPositionQuery()

  const handleClick: MouseEventHandler = (e) => {
    e.stopPropagation()

    void getRiskMapPosition(positionAndDangersId)

    toggleModalIsVisible(true)
  }

  const handleClose = () => {
    toggleModalIsVisible(false)
  }

  return (
    <div>
      <SecondaryButton
        isLoading={isLoading}
        leftIcon={<CopyOutlined />}
        onClick={handleClick}
      />
      {data && (
        <Modal
          onModalClose={handleClose}
          visible={modalIsVisible}
          withoutCloseOnOutsideClick
        >
          <PositionAndDangersModal
            riskMapPosition={{
              riskMapJobPositionDangers: data.riskMapJobPositionDangers,
            }}
            handleCloseModal={handleClose}
          />
        </Modal>
      )}
    </div>
  )
}

export default CopyPositionAndDangers
